import * as angular from "angular";

angular
  .module('bringoz.admin.oms')
  .filter('omsPackageWeight', omsPackageWeight);

function omsPackageWeight(splitService, $filter) {
  return function bringozOmsPackageWeight(packageRef, enableUnitDisplay) {

    if (!packageRef || !packageRef.weight) {
      return '--';
    }

    return $filter('bringozWeight')(packageRef.weight * (packageRef.count || 1), enableUnitDisplay);
  };
}
